import { createI18n } from "vue-i18n";

// 定義語言內容
const messages = {
  en: {
    // 標記工具
    lang: "中文",
    skipToMain: "Skip to main content",
    chatWithLLM: "Chat with LLM",
    send: "Send",
    sending: "Sending",
    imageSettings: "Image Settings",
    user: "User",
    LLM: "LLM",
    LLMChat: "LLM Chat",
    seed: "Seed",
    seedInfo: "'Seed' is a random number used to control the randomness of image generation in Stable Diffusion. When using the same seed with the same parameters, the generated image will be exactly the same.",
    getRandomSeed: "Click to randomly generate a seed.",
    enterSeedValue: "Enter a seed value",
    askAboutImageGeneration: "Ask me about image generation",
    basicParameter: "Basic Parameters",
    advanceParameter: "Advanced Parameters",
    loraWeight: "LoRA Model Strength",
    cfg: "cfg",
    steps: "steps",
    imageSize: "Image Width & Height",
    imageWidth: "Image Width",
    imageHeight: "Image Height",
    LoRAModel: "LoRA Model",
    prompt: "Prompt",
    negPrompt: "Negative Prompt",
    imageAreaTitle: "Generated Image",
    generateImage: "Generate Image",
    generating: "Generating",
    generateTips: "tips: Input a prompt, set your desired landmark, and quickly generate a custom image",
    generatingYouriImage: "Generating your image",
    noImageGenerated: "No image generated yet.",
    imageGeneration: "Image Generation",
    generationPreference: "Generation Preference",
    generationPreferenceInfo: "Choose whether the AI should prioritize preserving the original appearance of landmarks or prioritize bringing your prompt to life when generating images.",
    historicalPreferred: "Historical First",
    naturalBlend: "Natural Blend",
    promptPriority: "Prompt Priority",
    imageUpscale: "Image Upscale",
    imageInpainting: "Image Inpainting",
    uploadImage: "Upload Image",
    widthResolution: "Width Resolution",
    heightResolution: "Height Resolution",
    scaleFactor: "Scale Factor",
    upscaling: "Upscaling",
    upscaleTips: "tips: Adjust scaling from 0.1 to 4.0 times via slider to provide high-quality visual enhancement effects for images.",
    upscaleImage: "Upscale Image",
    noImageUpscaled: "No image upscaled yet",
    pleaseUploadImage: "Please upload a image first.",
    pleaseTakePhoto: "Please take a photo first",
    dragDropUpload: "Drag & Drop your image here",
    clickToUploadImage: "Click to upload image",
    or: "or",
    guidance: "guidance",
    inpaintImage: "Inpaint Image",
    inpaintingImage: "Inpainting Image...",
    inpaintTips: "tips: Draw on the image to select an area, adjust settings and description, then generate localized modifications",
    noImageInpainting: "No image inpainted yet",
    download: "Download",
    downloadImage: "Download Image",
    brushSize: "Brush Size",
    brushHardness: "Brush Hardness",
    clearMark: "Clear mark",
    clearImage: "Clear image",
    guidanceInfo: "This parameter determines how much the model should follow the user-entered prompts when generating results, rather than just filling in the original image, and is recommended to be set between 3 and 7",
    checkerTips: "tips: Supports image preview and feedback correction for precise data annotation and model optimization",
    // 時代肖像分頁
    timePortrait: "Portrait of Time",
    originPortrait: "Original Portrait",
    generateMyTimePortrait: "Generate My Portrait of Time",
    genderSelection: "Generate Gender",
    male: "Male",
    female: "Female",
    clickToTakePhoto: "Click to take photo",
    takePhoto: "Take photos",
    reshoot: "Reshoot",
    useThisPhoto: "Use this photo",
    clearData: "Clear data",
    scanToDownload: "Scan QR-Code to download your Portrait of Time",
    longPressToSave: "Long press the image after turning on the phone to save it.",
    cameraLoading: "Camera loading...",
    timePortraitTips: "tips: To ensure optimal period portrait generation results, it is recommended to shoot in well-lit conditions and avoid having bangs cover the eyebrows for the best time-travel effect. Additionally, select the correct generation gender to ensure accurate alignment between period attire and portrait style.",
    printImage: "Print Image",
    printPopupBlocked: "The browser blocked the print window. Please allow pop-ups and try again.",
    downloadYourTimePortrait: "Download Your Time Portrait",
    displayConsentLabel: "I consent to the organizer displaying this Time Portrait at the event venue",
    displayConsentDescription: "If you do not consent, you can still use the QR code to download the digital file, but you will not be able to print it.",
    agreeBeforePrint: "Please check the box to agree to the display first",
    processing: "Processing...",
    displayConsentUpdateFailed: "Failed to update the consent status for venue playback. Please try again later.",
    // 生圖網站
    selectLandmark: "Select a Landmark to Generate",
    imageChecker: "Image Checker",
    userManagement: "User Management",
    welcome: "Welcome login",
    platform: "Cultural Content Development Platform",
    login: "Login",
    loggingIn: "Logging in...",
    logout: "Logout",
    backToHome: "Back to home",
    confirmLogout: "Are you sure you want to log out?",
    userAccount: "User account",
    enterAccount: "Enter your account",
    account: "Account",
    enterPassword: "Enter your password",
    passwordLabel: "Password",  // NOSONAR
    submit: "Submit",
    wrongNameOrPwd: "Incorrect username or password.",
    loginFail: "Login failed, please try again later.",
    noPermission: "No permission, please contact the backend administrator.",
    loadingImage: "Loading image...",
    previous: "Previous",
    next: "Next",
    image: "Image",
    switchDataset: "Switch dataset",
    openImageDirectory: "Open image directory",
    markedAndSaved: "Marked and saved",
    markedAndSavedText: "Marked and updated!",
    autoPrompt: "Auto-generated Prompt",
    userPrompt: "User-corrected Prompt",
    calculating: "Calculating",
    calculateCLIPScore: "Calculate CLIP Score",
    selectDataset: "Select dataset",
    description: "Description",
    imageFolderPath: "Image folder path",
    numsOfImages_1: "Number of",
    numsOfImages_2: " images",
    imageNumber: "Number",
    imageName: "Image name",
    mark: "Mark",
    info: "Inform",
    imageDirectory: "Image directory",
    addUser: "Add account",
    addConfirm: "Add confirm",
    train: "Train",
    inference: "Inference",
    annotate: "Annotate",
    noImageSelected: "No image generated yet.",
    manage: "Manage",
    actions: "Actions",
    delete: "Delete",
    cancel: "Cancel",
    ok: "OK",
    confirmDelete: "Confirm Delete",
    confirmDeleteText: "Are you sure you want to delete this user?",
    userAddSuccess: "User added successfully!",
    userAlreadyExist: "Username already exists",
    accountNoEmpty: "Account cannot be empty",
    passwordRequiredMsg: "Password cannot be empty",  // NOSONAR
    permissionSetting: "Permission setting",
    userAddFail: "Add user failed",
    userDeleteSuccess: "User deleted successfully!",
    userDeleteFail: "Delete user failed",
    // 標記工具2025/08新增欄位
    aiAutoTagging: "AI Automatic Tagging",
    era: "Era",
    ad: "A.D.",
    region: "Region",
    city: "County/City",
    township: "Township/District ",
    notes: "Notes (optional)",
    fourCategories: "Four Major Categories",
    artificial: "Artificial",
    metadata: "Metadata",
    lastEdited: "Last edited:",
    pleaseSelect: "Please select",
    poiExample: "Example: Zhongyi Elementary School",
    cat_1: "Historic Street Scenes and Heritage Buildings",
    cat_2: "Traditional Attire and Folk Crafts",
    cat_3: "Folk Activities and Festival Ceremonies",
    cat_4: "Natural Environment and Local Events",
    noMetadata: "This image has no metadata.",
    yearStart: "Starting Year",
    yearEnd: "Ending Year",
    yearError_1: "The year must be entered as a four-digit Gregorian calendar year.",
    yearError_2: "The year must be entered as a four-digit Gregorian calendar year.",
    yearError_3: "The starting year shall not be greater than the ending year.",
    distError: "Township and urban districts are not part of that city.",
    // 首頁多語系內容
    tainanCity: "Tainan City",
    culturalContentPlatform: "Tainan City Cultural Content Development Platform",
    useNow: "Use Now →",
    // Info card 動畫內容
    infoCard1Text1: "Cultural Content Platform,<br>Tainan Culture meets AI Technology",
    infoCard1Text2: "Latest AI Technology<br>Recreating Tainan's Cultural Heritage",
    infoCard2Text1: "Based on precious old photos,<br>Building Tainan's AI image model.",
    infoCard2Text2: "History meets Technology,<br>Creating Tainan's digital culture.",
    imageGenerationTitle: "Image Generation",
    imageGenerationDesc1: "Use AI to generate images by simply entering a prompt and selecting the landmark you want to create. The generated image will be displayed instantly, allowing you to preview and download it.",
    imageGenerationDesc2: "Integrated with Ollama LLM chat functionality, get personalized image generation suggestions and professional Prompt guidance through conversations with AI chatbots.",
    llmChatWindow: "LLM Chat Window",
    imageUpscaleTitle: "Image Upscale",
    imageUpscaleDesc: "Supports 0.1~4.0x image scaling with high-quality visual enhancement effects. Generated images can be immediately previewed and downloaded for easy adjustment of subsequent uses.",
    imageInpaintingTitle: "Image Inpainting",
    imageInpaintingDesc: "Select specified areas in images, enter repair or redraw descriptions, and AI generates local modification results in real-time. Results are displayed synchronously for easy viewing and downloading.",
    imageCheckerTitle: "Image Checker",
    imageCheckerDesc: "Provides graphical interface for Prompt correction and real-time CLIP Score calculation as reference. Supports image preview and correction feedback to assist accurate data annotation and subsequent model optimization.",
    dataSourceText: "This Cultural Content Development Platform thanks all parties for their support, especially the Tainan Cultural Foundation, Mr. Wang Zi-Shuo, and other organizations and individuals for providing precious cultural image materials for AI training. These materials not only enrich the platform's local cultural foundation but also allow Tainan's historical memories to be continued and reproduced digitally.",
    // 可選擇生成之景點
    hayashi: "Hayashi Department Store",
    tnnStation: "Tainan Train Station (Second-generation current station building)",
    tnnStationWood: "Tainan Train Station (First-generation wooden station building)",
    chihkan: "Chihkan Tower",
    greatSouthGate: "Great South Gate",
    tangTeChang: "Tang Te-chang Memorial Park",
    tainanPGB: "Former Tainan Prefectural Government building-National Museum of Taiwan Literature",
    grandMatsuTemple: "Grand Matsu Temple",
    tnnPublicHall: "Tainan Public Hall",
    tnnConfuciusTemple: "Tainan Confucius Temple",
    tnnArtMuseum: "Tainan Art Museum",
    formerTnnMS: "Former Tainan Meteorological Station",
    tnnDistrictCourt: "Tainan District Court",
    anpingOldFort: "Anping Old Fort",
    tnnWestMarket: "Tainan West Market",
    wuFamilyGarden: "Wu Family Garden",
    TainanWudeHall: "Tainan Wude Hall",
    eternalgoldenfort: "Eternal Golden Fort",
    tcMerchantHouse: "Tait & Co. Merchant House",
    genLandmarks: "Generate Japanese Colonial Period landmarks",
    noGenLandmarks: "Do not generate landmarks",
    tainanStyleOfTapanColonial: "The Tainan Style of the Japanese Colonial Period",
    none: "None",
    eraAndStyle: "Era and Style",
    style: "Style",
    japColPeriod: "Japanese Colonial Period",
    normal: "Normal",
    blackAndWhite: "Black-and-white",
    oldStyle: "old style",
    // User Terms
    agreeTerms: "By using this platform, you agree to the platform regulations. For details, please refer to the ",
    userTerms: "\"User Terms\"",
    userTermsTitle: "Tainan AI Cultural Image Generation Service - User Terms",
    lastUpdated: "Last Updated:",
    updateDate: "2025.11.14",
    backToLogin: "Back to Login",
    copyright: "© 2025 Tainan City Government. All rights reserved.",
    termsIntro: "Welcome to the \"Tainan AI Cultural Image Generation Service\" (hereinafter referred to as \"the Service\") provided by the Tainan City Government (hereinafter referred to as \"the Government\"). To protect your rights and clarify the rights and obligations of both parties, please read the following User Terms (hereinafter referred to as \"these Terms\") carefully before using the Service. When you begin using the Service, you are deemed to have read, understood, and fully agreed to accept all contents of these Terms. If you do not agree with the contents of these Terms, please immediately cease using the Service.",
    article1Title: "Article 1: Service Description",
    article1Item1: "The Service aims to transform Tainan's local historical image data into innovative visual art through artificial intelligence models, for the purpose of promoting local culture and revitalizing historical memory.",
    article1Item2: "Users can generate AI-created images by inputting text prompts.",
    article1Item3: "Users should recognize that all images generated by the Service are created by AI algorithms, are not actual historical photographs, have no factual basis, and do not represent the position or viewpoint of the Government.",
    article1Item4: "Due to changes in laws and policies, force majeure, or other reasons beyond the Service's control, the Service may cease to be provided at any time without further notice.",
    article2Title: "Article 2: User Conduct Standards and Responsibilities",
    article2Item1: "Users shall bear complete and independent legal responsibility for their input prompts, generated images, and subsequent use of those images.",
    article2Item2: "Users undertake never to use the Service to engage in any conduct that infringes upon the rights of others or violates the law, including but not limited to:",
    article2Sub1Title: "Prohibition on generating defamatory or insulting content:",
    article2Sub1Text: "Users shall not create any images that contain defamation, slander, insult, threat, discrimination, or personal attacks against specific or non-specific individuals, groups, ethnic groups, religions, or countries.",
    article2Sub2Title: "Prohibition on generating indecent and pornographic content:",
    article2Sub2Text: "Users shall not create any images containing pornography, nudity, obscenity, sexual innuendo, or any content considered offensive to public morals under the laws of the Republic of China.",
    article2Sub3Title: "Prohibition on generating violent and hateful content:",
    article2Sub3Text: "Users shall not create any images depicting gore, violence, self-harm, terrorism, or inciting hatred.",
    article2Sub4Title: "Prohibition on creating and disseminating false information:",
    article2Sub4Text: "Users shall not use generated images to fabricate facts, spread rumors, or engage in any form of fraudulent conduct intended to mislead the public.",
    article2Sub5Title: "Prohibition on infringing intellectual property rights:",
    article2Sub5Text: "Users shall not input any text that may infringe upon others' copyrights, trademark rights, or other intellectual property rights, or attempt to generate such infringing images.",
    article2Sub6Title: "Prohibition on infringing privacy rights:",
    article2Sub6Text: "Users shall not use the Service to create images that violate others' privacy, portrait rights, or personal data.",
    article2Sub7Title: "Prohibition on use for fraud or other deceptive conduct:",
    article2Sub7Text: "Users shall not create any content with fraudulent, counterfeit, misleading, or deceptive intent, including but not limited to forging identities, impersonating others, or inducing others to surrender property, provide information, or engage in illegal conduct.",
    article2Item3: "If users violate the above provisions, in addition to bearing relevant legal responsibilities, the Government has the right to immediately suspend or permanently terminate that user's access rights without further notice.",
    article2Item4: "To assist courts, prosecutors' offices, police, or investigation agencies in conducting investigations into crimes or illegal conduct in accordance with the law, the Government may provide usage records or information of the Service for their retrieval, review, or use.",
    article3Title: "Article 3: Disclaimer",
    article3Item1: "The Service is provided on an \"As Is\" and \"As Available\" basis. The Government does not provide any express or implied warranty regarding the accuracy, completeness, timeliness, or suitability for specific purposes of generated images.",
    article3Item2: "The Government has established filtering and review mechanisms to reduce the probability of generating inappropriate content, but cannot guarantee 100% interception of all inappropriate content.",
    article3Item3: "The Government shall not be responsible for any direct, indirect, derivative, incidental, or punitive damages or legal disputes (including but not limited to reputational damage, business interruption, legal litigation, etc.) arising from any user's own conduct (such as inputting inappropriate prompts) or use and dissemination of generated images.",
    article4Title: "Article 4: Indemnification",
    article4Item1: "If, due to a user's violation of these Terms or their conduct in using generated images, the Government or its affiliated personnel suffer any third-party claims, lawsuits, losses, or incur any expenses (including but not limited to reasonable attorney's fees), the user agrees to bear full indemnification responsibility to the Government.",
    article5Title: "Article 5: Amendment of Terms",
    article5Item1: "The Government reserves the right to modify these Terms at any time. Modified Terms will be published on the Service website without individual notice. If you continue to use the Service after the Terms have been modified, you will be deemed to have agreed to accept such modifications.",
    article6Title: "Article 6: Governing Law and Jurisdiction",
    article6Item1: "The interpretation and application of these Terms, as well as disputes arising from the Service, shall be governed by the laws of the Republic of China. All disputes, controversies, or disagreements arising from the use of the Service or violation of these Terms shall first be negotiated in good faith. If negotiation fails and litigation ensues, users agree that the Taiwan Tainan District Court shall be the court of first instance jurisdiction.",
    microFilmDescription: "This film is a fully AI-generated visual work. During the creative process, the 'Cultural Content Development Platform' was employed, based on over ten thousand historical images collected from Tainan, to generate multiple images with a period atmosphere. Then, according to the story context, a script for image transitions was written to transform static images into a continuous, flowing visual narrative.",
    // QRCode
    qrcodeTitle: "Scan the QR code to download the image.",
    qrcodeGenerating: "Generating QR Code...",
    copyLink: "Copy link",
    close: "Close",
  },
  zh: {
    lang: "EN",
    skipToMain: "跳到主要內容",
    chatWithLLM: "與 LLM 聊天",
    send: "傳送",
    sending: "傳送中",
    imageSettings: "圖片設置",
    user: "使用者",
    LLM: "LLM",
    LLMChat: "LLM聊天",
    seed: "種子",
    seedInfo: "種子是一個隨機數，用於控制圖片生成的隨機性。使用相同的種子和相同的參數會生成完全一致的圖片。",
    getRandomSeed: "點擊隨機生成種子",
    enterSeedValue: "輸入種子的值",
    askAboutImageGeneration: "詢問我關於圖片生成的事",
    basicParameter: "基本參數",
    advanceParameter: "進階參數",
    loraWeight: "LoRA模型權重",
    cfg: "cfg",
    steps: "steps",
    imageSize: "圖片寬度與高度",
    imageWidth: "圖片寬度",
    imageHeight: "圖片高度",
    LoRAModel: "LoRA 模型",
    prompt: "提示詞輸入",
    negPrompt: "負面提示詞",
    imageAreaTitle: "生成的圖片",
    generateImage: "生成圖片",
    generating: "生成中",
    generateTips: "tips: 輸入提示詞（Prompt）、設定想生成的地標，就能快速產生專屬影像",
    generatingYouriImage: "生成您的圖片中",
    noImageGenerated: "尚未生成圖片",
    imageGeneration: "圖片生成",
    generationPreference: "生成偏好",
    generationPreferenceInfo: "選擇 AI 在生成圖片時，要優先保留地標的原始樣貌，還是優先實現您輸入的提示詞創意。",
    historicalPreferred: "忠於歷史",
    naturalBlend: "自然融合",
    promptPriority: "提示詞優先",
    imageUpscale: "圖片縮放",
    imageInpainting: "圖片局部重繪",
    uploadImage: "上傳圖片",
    widthResolution: "寬精細度",
    heightResolution: "長精細度",
    scaleFactor: "縮放倍數",
    upscaling: "縮放中",
    upscaleTips: "tips: 可透過滑桿體整 0.1～4.0 倍的縮放，提供圖片高品質的視覺增強效果",
    upscaleImage: "縮放圖片",
    noImageUpscaled: "尚未縮放圖片",
    pleaseUploadImage: "請先上傳圖片",
    pleaseTakePhoto: "請先拍攝照片",
    dragDropUpload: "將圖片拖曳至此",
    clickToUploadImage: "點擊上傳圖片",
    or: "或",
    guidance: "引導強度",
    inpaintImage: "重繪圖片",
    inpaintingImage: "重繪圖片中...",
    inpaintTips: "tips: 在圖片中繪製指定區域，調整數值與重繪描述，即可生成局部修改結果",
    noImageInpainting: "尚未重繪圖片",
    download: "下載",
    downloadImage: "下載圖片",
    brushSize: "筆刷大小",
    brushHardness: "筆刷硬度",
    clearMark: "清除標記",
    clearImage: "清除圖片",
    guidanceInfo: "這個參數決定模型在生成結果時，應該多大程度地遵循使用者輸入的提示詞（Prompt），而非僅根據原始圖像進行填補，建議設定3~10",
    checkerTips: "tips: 支援圖片預覽及校正回饋，協助精準資料標註與後續模型優化",
    // 時代肖像分頁
    timePortrait: "時代肖像",
    originPortrait: "原始肖像",
    generateMyTimePortrait: "生成我的時代肖像",
    genderSelection: "生成性別",
    male: "男",
    female: "女",
    clickToTakePhoto: "點擊拍攝照片",
    takePhoto: "拍攝照片",
    reshoot: "重拍",
    useThisPhoto: "使用此照片",
    clearData: "清除資料",
    scanToDownload: "掃描QR-Code下載你的時代肖像",
    longPressToSave: "手機開啟後長按圖片即可儲存",
    cameraLoading: "相機啟動中...",
    timePortraitTips: "tips: 為確保最佳的時代肖像生成效果，建議拍攝時光源充足、避免劉海遮擋眉毛，以獲得最佳穿越效果，並選擇正確的生成性別，以確保時代服飾與人像風格的準確契合。",
    printImage: "列印圖片",
    printPopupBlocked: "瀏覽器封鎖了列印視窗，請允許彈出視窗後再試一次。",
    downloadYourTimePortrait: "下載你的時代肖像",
    displayConsentLabel: "我同意主辦單位於本次活動現場播放此時代肖像",
    displayConsentDescription: "若不同意，仍可使用 QRCode 下載電子檔，但無法進行列印。",
    agreeBeforePrint: "請先勾選同意展出",
    processing: "處理中...",
    displayConsentUpdateFailed: "更新展場播放同意狀態失敗，請稍後再試。",
    // 生圖網站
    selectLandmark: "請選擇生成地標",
    imageChecker: "圖片校正標記",
    userManagement: "使用者管理",
    welcome: "歡迎登入",
    platform: "臺南市文化內容生成平台",
    login: "登入",
    loggingIn: "登入中...",
    logout: "登出",
    backToHome: "返回首頁",
    confirmLogout: "確定要登出嗎？",
    userAccount: "使用者帳號",
    enterAccount: "請輸入你的帳號",
    account: "帳號",
    enterPassword: "請輸入你的密碼",
    passwordLabel: "密碼",  // NOSONAR
    submit: "送出",
    wrongNameOrPwd: "帳號或密碼錯誤",
    loginFail: "登入失敗，請稍後再試",
    noPermission: "無權限，請連絡後台管理員",
    loadingImage: "載入圖片中...",
    previous: "上一張",
    next: "下一張",
    image: "圖片",
    switchDataset: "切換資料集",
    openImageDirectory: "開啟圖片目錄",
    markedAndSaved: "註記為已校正並儲存",
    markedAndSavedText: "已註記並更新完畢!",
    autoPrompt: "自動產生提示詞 (Auto Prompt)",
    userPrompt: "人工校正提示詞 (User Prompt)",
    calculating: "計算中",
    calculateCLIPScore: "計算CLIP Score",
    selectDataset: "選擇資料集",
    description: "描述",
    imageFolderPath: "圖片資料夾路徑",
    numsOfImages_1: "圖片",
    numsOfImages_2: "數量",
    imageNumber: "編號",
    imageName: "圖片名稱",
    mark: "校正",
    info: "通知",
    imageDirectory: "圖片目錄",
    addUser: "新增使用者",
    addConfirm: "新增確認",
    train: "訓練",
    inference: "推論",
    annotate: "校正與標記",
    noImageSelected: "尚未選擇圖片",
    manage: "權限管理",
    actions: "操作",
    delete: "刪除",
    cancel: "取消",
    ok: "好",
    confirmDelete: "確認刪除",
    confirmDeleteText: "您確定要刪除此使用者嗎？",
    userAddSuccess: "使用者已成功新增！",
    userAlreadyExist: "使用者名稱已存在",
    accountNoEmpty: "帳號不能為空",
    passwordRequiredMsg: "密碼不能為空",  // NOSONAR
    permissionSetting: "權限設置",
    userAddFail: "新增使用者失敗",
    userDeleteSuccess: "使用者已成功刪除！",
    userDeleteFail: "刪除使用者失敗",
    // 標記工具2025/08新增欄位
    aiAutoTagging: "AI 自動標記",
    era: "年代",
    ad: "西元",
    region: "地區",
    city: "縣市",
    township: "鄉鎮市區",
    notes: "備註(選填)",
    fourCategories: "四大分類",
    artificial: "人工",
    metadata: "後設資料",
    lastEdited: "最後編輯：",
    pleaseSelect: "請選擇",
    poiExample: "例：忠義國小",
    cat_1: "歷史街景與古蹟建築",
    cat_2: "傳統服飾與民俗工藝",
    cat_3: "民俗活動與節慶儀式",
    cat_4: "自然環境與地方事件",
    noMetadata: "此圖無後設資料",
    yearStart: "起年",
    yearEnd: "迄年",
    yearError_1: "起年必須為四位西元年",
    yearError_2: "迄年必須為四位西元年",
    yearError_3: "起年不可大於迄年",
    distError: "鄉鎮市區不屬於該城市",
    // 首頁多語系內容
    tainanCity: "臺南市",
    culturalContentPlatform: "文化內容生成平台",
    useNow: "立即使用 →",
    // Info card 動畫內容
    infoCard1Text1: "文化內容生成平台，<br>結合臺南在地文化與 AI 技術",
    infoCard1Text2: "運用最新 AI 技術，<br>重現臺南百年文化風華",
    infoCard2Text1: "以珍貴的老照片為基礎，<br>打造臺南文化影像生成模型",
    infoCard2Text2: "融合歷史與科技，<br>創造臺南的數位文化體驗",
    imageGenerationTitle: "圖片生成",
    imageGenerationDesc1: "利用 AI 生成圖片，只需輸入提示詞（Prompt）、設定想生成的地標，快速產生專屬影像。生成後的圖片將即時顯示，可預覽及下載",
    imageGenerationDesc2: "整合 Ollama LLM 聊天功能，透過與 AI 機器人對話，獲取個人化的圖片生成建議和專業 Prompt 引導。",
    llmChatWindow: "與LLM的聊天視窗",
    imageUpscaleTitle: "圖片縮放",
    imageUpscaleDesc: "支援 0.1～4.0 倍的圖片縮放，提供高品質視覺增強效果。生成後圖片可立即預覽及下載，方便調整後續用途",
    imageInpaintingTitle: "圖片局部重繪",
    imageInpaintingDesc: "選取圖片指定區域，輸入修復或重繪描述，AI 即時生成局部修改結果。結果將同步顯示，方便檢視與下載",
    imageCheckerTitle: "圖片校正標記",
    imageCheckerDesc: "提供圖形化介面進行 Prompt 校正，並即時計算 CLIP Score 作為依據。支援圖片預覽及校正回饋，協助精準資料標註與後續模型優化。",
    dataSourceText: "「本文化內容生成平台感謝各界支持，特別鳴謝臺南市文化基金會、王子碩先生等單位與人士，提供珍貴的文化影像資料作為 AI 訓練使用。這些資料不僅豐富了平台的在地文化基礎，也讓臺南的歷史記憶能以數位方式延續與再現。」",
    // 可選擇生成之景點
    hayashi: "林百貨",
    tnnStationWood: "台南火車站 (第一代木造站體)",
    tnnStation: "台南火車站 (第二代現有站體)",
    chihkan: "赤崁樓",
    greatSouthGate: "大南門",
    tangTeChang: "湯德章紀念公園",
    tainanPGB: "原台南州廳-台灣文學館",
    grandMatsuTemple: "大天后宮",
    tnnPublicHall: "台南公會堂",
    tnnConfuciusTemple: "台南孔廟",
    tnnArtMuseum: "台南美術館",
    formerTnnMS: "台南測候所",
    tnnDistrictCourt: "台南地方法院",
    anpingOldFort: "安平古堡",
    tnnWestMarket: "台南西市場",
    wuFamilyGarden: "吳園",
    TainanWudeHall: "台南武德殿",
    eternalgoldenfort: "億載金城",
    tcMerchantHouse: "德記洋行",
    genLandmarks: "生成日治時期地標",
    noGenLandmarks: "不生成地標",
    tainanStyleOfTapanColonial: "台南日治風格",
    none: "無",
    eraAndStyle: "年代與風格",
    style: "風格",
    japColPeriod: "日治時期",
    normal: "普通",
    blackAndWhite: "黑白",
    oldStyle: "老照片",
    // User Terms
    agreeTerms: "使用本平台即表示您同意平台規範，詳情請參考 ",
    userTerms: "「使用者規範」",
    userTermsTitle: "臺南 AI 文化圖像生成服務使用者條款",
    lastUpdated: "最近更新日期:",
    updateDate: "2025.11.14",
    backToLogin: "回到登入頁",
    copyright: "© 2025 臺南市政府 版權所有",
    termsIntro: "歡迎您使用由臺南市政府(下稱「本府」)提供之「臺南 AI 文化圖像生成服務」(下稱「本服務」)。為保障您的權益,並釐清雙方之權利義務,請於使用本服務前,詳細閱讀以下使用者條款(下稱「本條款」)。當您開始使用本服務時,即視為您已閱讀、瞭解並完全同意接受本條款之所有內容,如您不同意本條款內容,請立即停止使用本服務。",
    article1Title: "第一條:服務說明",
    article1Item1: "本服務旨在透過人工智慧模型,將台南在地歷史影像資料轉化為創新的視覺藝術,以推廣在地文化、活化歷史記憶為目的。",
    article1Item2: "使用者可透過輸入文字提示詞(Prompt),生成由 AI 創作的圖像。",
    article1Item3: "使用者應認知,本服務生成之所有圖像均為 AI 演算法所創造,並非真實歷史照片,不具備任何事實根據,亦不代表本府之立場或觀點。",
    article1Item4: "因法律政策變動、不可抗力或其他非本服務可控之事由,本服務得隨時停止提供,且不另行通知。",
    article2Title: "第二條:使用者行為規範與責任",
    article2Item1: "使用者應對其輸入的提示詞、生成的圖像,以及對該圖像的後續使用,負擔完全且獨立的法律責任。",
    article2Item2: "使用者承諾絕不利用本服務從事任何侵害他人權益或違法之行為,包括但不限於:",
    article2Sub1Title: "禁止生成毀謗、侮辱性內容:",
    article2Sub1Text: "不得製作任何針對特定或不特定個人、團體、族群、宗教或國家,帶有毀謗、中傷、侮辱、威脅、歧視或人身攻擊之圖像。",
    article2Sub2Title: "禁止生成不雅與色情內容:",
    article2Sub2Text: "不得製作任何包含色情、裸露、猥褻、性暗示或任何依中華民國法律被視為妨害風化之圖像。",
    article2Sub3Title: "禁止生成暴力與仇恨內容:",
    article2Sub3Text: "不得製作任何描繪血腥、暴力、自殘、恐怖主義或煽動仇恨之圖像。",
    article2Sub4Title: "禁止製作與散播不實資訊:",
    article2Sub4Text: "不得利用生成之圖像捏造事實、散播謠言或從事任何形式的詐欺行為,意圖誤導公眾。",
    article2Sub5Title: "禁止侵害智慧財產權:",
    article2Sub5Text: "不得輸入任何可能侵害他人著作權、商標權等智慧財產權之文字,或意圖生成此類侵權圖像。",
    article2Sub6Title: "禁止侵害隱私權:",
    article2Sub6Text: "不得利用本服務製作侵犯他人隱私、肖像權或個資之圖像。",
    article2Sub7Title: "禁止用於詐騙或其他欺罔行為:",
    article2Sub7Text: "不得製作任何具有詐騙、偽冒、誤導或欺罔意圖之內容,包括但不限於偽造身分、冒用他人名義,或誘使他人交付財物、提供各資或從事不法行為之圖像。",
    article2Item3: "若使用者違反上述規定,除應自負相關法律責任外,本府有權立即暫停或永久終止該使用者之存取權限,不另行通知。",
    article2Item4: "為協助法院、檢察機關、警察或調查單位依法進行犯罪或違法行為之調查,本府得提供本服務之使用紀錄或資訊,供其調取、查閱或利用。",
    article3Title: "第三條:免責聲明",
    article3Item1: "本服務係以「現況」(As Is)及「現有」(As Available)之基礎提供,本府不對生成圖像的準確性、完整性、即時性或特定用途的適用性提供任何明示或默示的擔保。",
    article3Item2: "本府已建置過濾與審核機制,以期降低不當內容的生成機率,但無法保證能百分之百攔截所有不當內容。",
    article3Item3: "對於任何使用者因自身行為(如輸入不當提示詞)或使用、散布其生成之圖像所引發的任何直接、間接、衍生、附帶或懲罰性的損害或法律爭議(包含但不限於名譽損害、業務中斷、法律訴訟等),本府概不負責。",
    article4Title: "第四條:損害賠償",
    article4Item1: "若因使用者違反本條款之規定,或其使用生成圖像之行為,致使本府或其關聯人員遭受任何第三方之索賠、訴訟、損失、或產生任何費用(包括但不限於合理的律師費用),使用者同意對本府負起完全之損害賠償責任。",
    article5Title: "第五條:條款修訂",
    article5Item1: "本府保留隨時修改本條款之權利。修改後之條款將公布於本服務網站上,不另作個別通知。若您於條款修改後繼續使用本服務,將視為您已同意接受該等修改。",
    article6Title: "第六條:準據法與管轄法院",
    article6Item1: "本條款之解釋與適用,以及因本服務而生之爭議,均應以中華民國法律為準據法。因使用本服務或違反本條款所引發之一切糾紛、爭議或歧見,先本誠信原則協商之。協商不成而設訴訟時,使用者同意以臺灣臺南地方法院為第一審管轄法院。",
    microFilmDescription: "本片為全 AI 生成影像作品。\n創作過程中，運用「文化內容生成平台」，以臺南蒐集的一萬多張歷史影像為基礎，生成多張具時代氛圍的影像畫面，再依故事脈絡撰寫影像銜接腳本，將一張張靜態影像轉化為連續流動的影像敘事。",
    // QRCode
    qrcodeTitle: "掃描QRCode下載圖片",
    qrcodeGenerating: "QRCode產生中...",
    copyLink: "複製連結",
    close: "關閉",
  },
};

// 創建 i18n 實例
const i18n = createI18n({
  locale: "zh", // 預設語言
  fallbackLocale: "zh",
  messages,
});

export default i18n;
